var moment = require('moment');
var module = angular.module('octopusApp.configuration');

module.controller('NodesIndexController', function($scope, busy, octopusRepository, unsavedChanges, pollLoop, $window, $q) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();
  
  var loop = pollLoop.create($scope, function () { return refresh(); });
  var hardRefreshAt = moment().add(5,'hours');

  $scope.save = function(node) {
    isSaving.promise(octopusRepository.OctopusServerNodes.modify(node).then(function (result) {
      unsavedChanges.saved();
    }));
  };

  var refresh = function() {
    if (unsavedChanges.hasUnsavedChanges()) {
      return $q(function(resolve) { resolve(); });
    }
    
    if (moment() > hardRefreshAt) {
      $window.location.reload();
      loop.stop();
      return $q.defer().promise; // Never resolved
    }
    
    return isLoading.promise(octopusRepository.OctopusServerNodes.get().then(function(nodes) {
      $scope.nodes = nodes;
      if (!$scope.nodeTaskCount) {
        $scope.nodeTaskCount = [];
      }
      _.each(nodes.Items, function (node) {
        // Use the paging collection to figure out task TotalResults for each node (hence the take:1).
        isLoading.promise(octopusRepository.Tasks.filter({ node: node.Id, running: true, take:1 }).then(function (response) {
          $scope.nodeTaskCount[node.Id] = response.TotalResults;
        }));
      });
    }));
  };
  
  loop.startImmediately();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/nodes/controllers/nodes_index_controller.js
// module id = 395
// module chunks = 1